/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connector: NonNullable<unknown> }} Agent_Scope_Connection_NoneInputs */



/**
* | output |
* | --- |
* | "You have no {connector} connection yet. Connect one under Integrations, or remove the {connector} abilities." |
*
* @param {Agent_Scope_Connection_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_scope_connection_none = /** @type {((inputs: Agent_Scope_Connection_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Scope_Connection_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie haben noch keine ${i?.connector}-Verbindung. Verbinden Sie eine unter Integrationen, oder entfernen Sie die ${i?.connector}-Fähigkeiten.`)
	return /** @type {LocalizedString} */ (`You have no ${i?.connector} connection yet. Connect one under Integrations, or remove the ${i?.connector} abilities.`)
});